import {Component, Prop, Mixins} from "vue-property-decorator";
import VueSimpleSpinner from "vue-simple-spinner";
import {ContactModel} from "@/components/communications/models/contactModel";
import FormatMixin from "@/mixins/FormatMixin";
import {HTTP} from "@/utils/httpCommonUtil";

@Component(
  {
    components: {
      VueSimpleSpinner,
    }
  }
)
export default class NewCampaignResultsDisplay extends Mixins(FormatMixin) {

  @Prop({type: [Array], required: false, default: []})
  contacts!: ContactModel[];

  @Prop({type: String, required: false, default: 'Search Results'})
  header!: string;
  @Prop({type: String, required: false, default: 'Select All'})
  selectAllText!: string;
  @Prop({type: Boolean, required: false, default: false})
  loading!: boolean;
  @Prop({type: Boolean, required: false, default: false})
  showCount!: boolean;
  @Prop({type: String, required: false, default: ''})
  overrideStyle!: string;
  @Prop({type: Number, required: true, default: 1})
  selectedMessageType!: number;
  @Prop({type: Number, required: false, default: 1})
  selectedContactType!: number;
  @Prop({type: Number, required: false, default: 1})
  step!: number;
  @Prop({type: Boolean, required: false, default: false})
  contactGroupUploaded!: boolean;
  @Prop({type: Number, required: false, default: 0})
  loadedGroupId!: number;
  @Prop({type: String, required: false, default: ''})
  loadedGroupName!: string;
  @Prop({type: Boolean, required: false, default: false})
  sameGroup!: boolean;
  @Prop({type: Boolean, required: false, default: false})
  styleSelected!: boolean;

  protected newGroupInput = "";

  get styleObject(): Object {
    if(!this.overrideStyle){
      return {};
    }
    return {
      backgroundColor:this.overrideStyle
    }
  }

  get saveDisabled(): boolean {
    return this.newGroupInput.length === 0;
  }

  modelClicked(model: ContactModel) {
    this.$emit('modelClicked', model);
  }

  getContactLocation(contact: ContactModel): string {
    const cityState = [contact.city, contact.state].filter(Boolean).join(", ");
    return contact.facilityName || `${cityState} ${contact.zip || ''}`;
  }

  selectAll() {
    this.$emit('selectAll');
  }

  isDisabled(contact: ContactModel): boolean {
    return (this.selectedMessageType === 1 && !contact.receiveSMSBroadcast) || (this.selectedMessageType === 2 && !contact.receiveEmailBroadcast);
  }

  getIconClass(contact: ContactModel){
    switch(contact.statusId){
      case 1:
        return 'icon-custom-pending color-yellow';
      case 2:
        return 'icon-custom-active color-green';
      case 3:
        return 'icon-custom-inactive color-gray';
      default:
        return '';
    }
  }

  async saveGroup(contacts: ContactModel[]) {
    try {
      const contactIds = contacts.map((contact: ContactModel) => contact.id);
      await HTTP.post('/api/communication-campaigns/contact-group/', {
        groupName: this.newGroupInput,
        contactIds: contactIds,
        contactTypeId: this.selectedContactType
      });
    } catch (ex) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Saving Contact Group',
        text: 'Something went wrong saving contact group!',
      });
    } finally {
      this.newGroupInput = '';
    }
  }

  async updateGroup(contacts: ContactModel[]) {
    try {
      const contactIds = contacts.map((contact: ContactModel) => contact.id);
      await HTTP.put('/api/communication-campaigns/update-contact-group/' + this.loadedGroupId, {
        contactIds: contactIds,
        contactTypeId: this.selectedContactType
      });
    } catch (ex) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Updating Contact Group',
        text: 'Something went wrong updating contact group!',
      });
    } finally {
      this.newGroupInput = '';
      this.$emit('updateOriginalGroupIds', contacts);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/communications/campaign/results/NewCampaignResultsDisplay.ts